import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useWarehouse } from "@/contexts/WarehouseContext";
import { Warehouse, MapPin } from "lucide-react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { formatCurrency, formatNumber } from "@/lib/format";

export default function Magazijnen() {
  const { setWarehouse } = useWarehouse();
  const [warehouses, setWarehouses] = useState([]);

  useEffect(() => { api.get("/warehouses").then((r) => setWarehouses(r.data)); }, []);

  return (
    <div className="px-4 md:px-8 lg:px-12 py-8 md:py-10" data-testid="warehouses-page">
      <PageHeader
        eyebrow="Locaties"
        title="Magazijnen"
        description="Voorraad ligt op twee locaties. Van den Brink wordt handmatig ingevuld; Kipkruiden = webshoptotaal min Van den Brink."
      />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {warehouses.map((w) => (
          <Link key={w.id} to="/voorraad" onClick={() => setWarehouse(w.id)}
            data-testid={`warehouse-card-${w.id}`}
            className="surface p-8 hover:border-primary/40 transition-colors block">
            <div className="flex items-start gap-4">
              <div className="p-3 rounded-md bg-primary/10 text-primary">
                <Warehouse className="w-8 h-8" />
              </div>
              <div className="flex-1">
                <h3 className="text-2xl font-semibold">{w.name}</h3>
                <div className="flex items-center gap-2 text-sm text-muted-foreground mt-1">
                  <MapPin className="w-4 h-4" /> <span data-testid={`warehouse-location-${w.id}`}>{w.location}</span>
                </div>
                <div className="text-sm mt-1" data-testid={`warehouse-description-${w.id}`}>{w.description}</div>
              </div>
            </div>
            <div className="grid grid-cols-3 gap-4 mt-8">
              <Stat label="Producten" value={w.product_count} />
              <Stat label="Totaal eenheden" value={w.total_units === null ? "—" : formatNumber(w.total_units, 0)} />
              <Stat label="Voorraadwaarde" value={w.total_value === null ? "—" : formatCurrency(w.total_value)} />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

function Stat({ label, value }) {
  return (
    <div>
      <div className="text-[10px] uppercase tracking-widest text-muted-foreground">{label}</div>
      <div className="font-mono font-semibold text-xl mt-1">{value}</div>
    </div>
  );
}
